import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronRight } from 'lucide-react';
import './ConnectionGroups.css';

/**
 * A connection list split by the project scope (cards 5.2–5.4): the active
 * project's connections under its name, then "Other connections" (collapsible).
 * Under All projects it renders the rows as they are, no headers. `renderRow`
 * is the list's own row, unchanged.
 *
 * `groups` comes from scope/useConnectionProjectGroups.
 */
export default function ConnectionGroups({ groups, renderRow }) {
  const { t } = useTranslation();
  if (!groups.grouped) return groups.others.map(renderRow);
  const title = groups.projectName || t('projectScope.none', 'No project');
  return (
    <>
      <div className="conn-group-head" role="presentation">
        <span className="conn-group-title">{title}</span>
        <span className="conn-group-count">{groups.top.length}</span>
      </div>
      {groups.top.length ? groups.top.map(renderRow) : <div className="conn-group-empty">{t('projectScope.noConnections', 'None yet.')}</div>}
      {groups.others.length > 0 && (
        <>
          <button type="button" className="conn-group-head conn-group-head--toggle" aria-expanded={!groups.othersCollapsed} onClick={groups.toggleOthers}>
            {groups.othersCollapsed ? <ChevronRight size={12} aria-hidden /> : <ChevronDown size={12} aria-hidden />}
            <span className="conn-group-title">{t('projectScope.otherConnections', 'Other connections')}</span>
            <span className="conn-group-count">{groups.others.length}</span>
          </button>
          {groups.othersCollapsed ? null : groups.others.map(renderRow)}
        </>
      )}
    </>
  );
}
